import { UserBaseAllBaseReadUserAllUserReadUserItemRead } from '../../openapi';
import { createReducer, on } from '@ngrx/store';
import {
  loadUserDetails,
  loadUserDetailsFailure,
  loadUserDetailsSuccess,
  updateUserDetails, updateUserDetailsFailure, updateUserDetailsSuccess
} from '../actions/user-details.actions';

export type UserDetails = UserBaseAllBaseReadUserAllUserReadUserItemRead;

export interface UserDetailsState {
  loading: number;
  pending: number;
  user: UserDetails | null;
}

export const userDetailsInitialState: UserDetailsState = {
  loading: 0,
  pending: 0,
  user: null
};

export const userDetailsReducer = createReducer(
  userDetailsInitialState,
  on(loadUserDetails, state => ({ ...state, loading: state.loading + 1 })),
  on(loadUserDetailsSuccess, (state, action) => ({
    ...state,
    loading: state.loading - 1,
    user: action.user
  })),
  on(loadUserDetailsFailure, state => ({ ...state, loading: state.loading - 1 })),
  on(updateUserDetails, state => ({ ...state, pending: state.pending + 1 })),
  on(updateUserDetailsSuccess, (state, action) => ({ ...state, pending: state.pending - 1, user: action.user })),
  on(updateUserDetailsFailure, state => ({ ...state, pending: state.pending - 1 }))
);
